import "bootstrap/js/dist/collapse";

var Accordion = (function () {
    var $accordions, $card, $cardpanel, $cardbtn;

    function initialOpenFirstTab() {
        $accordions = $(".accordion__module");

        for (let i = 0; i < $accordions.length; i += 1) {
            var $accordion = $($accordions[i]);
            var showFirstTab = $accordion.data("show-first-tab");

            if (typeof (showFirstTab) != 'boolean') {
                showFirstTab = JSON.parse(showFirstTab.toLowerCase());
            } 

            if (showFirstTab) {
                $card = $accordion.find(".card").first();
                $cardbtn = $card.find(".card__button");
                $cardpanel = $card.find(".collapse");
                $cardpanel.addClass("show");
                $cardbtn.attr("aria-expanded", "true").removeClass("collapsed");
            }
        }
    }

    function init() {
        initialOpenFirstTab();
    }

    $(".collapse").on("show.bs.collapse", function () {
        const $card = $(this).closest(".card:visible");

        if ($card.length == 0) {
            return;
        }

        var $open = $($(this).data("parent")).find(".collapse.show");

        var additionalOffset = 0;
        if ($card.prevAll().filter($open.closest(".card")).length !== 0) {
            additionalOffset = $open.height();
        }

        $("html,body").animate({
            scrollTop: $card.offset().top - additionalOffset
        }, 500);
    });

    return {
        init: init
    };

})();

export { Accordion };